/**
 * Name of the icon in format `icon-<name>`
 */
export type IconIdentifier = string;

export type ItemContext = any;

export type QuickSettingsMenuItemId = number | string;

export enum QuickSettingsMenuType {
    Choice = "choice",
    Radio = "radio",
    Checkbox = "checkbox",
    Group = "group",
    Submenu = "submenu",
    Separator = "separator"
}

export interface IQuickSettingsMenuName {
    name?: string;
    nameLC?: string;
    help?: string;
    helpLC?: string;
}

export interface IQuickSettingsMenuRadioOption extends IQuickSettingsMenuName {
    value: boolean | number | string;
    className?: string;
}

interface IQuickSettingsMenuBase extends IQuickSettingsMenuName {
    id?: QuickSettingsMenuItemId;
    visible?: undefined | ((menuContext?: any) => boolean);
    className?: string;
}

export interface IQuickSettingsMenuGroup extends IQuickSettingsMenuBase {
    type: QuickSettingsMenuType.Group;
    children: IQuickSettingsMenuRegularItem[];
}

export interface IQuickSettingsMenuRadio extends IQuickSettingsMenuBase {
    type: QuickSettingsMenuType.Radio;
    valuePath: string;
    options: IQuickSettingsMenuRadioOption[] | (() => IQuickSettingsMenuRadioOption[]);
}

export interface IQuickSettingsMenuCheckbox extends IQuickSettingsMenuBase {
    type: QuickSettingsMenuType.Checkbox;
    valuePath: string;
}

export interface IQuickSettingsSubmenu extends Pick<
    IQuickSettingsMenuBase,
    Exclude<keyof IQuickSettingsMenuBase, "help" | "helpLC">
> {
    type: QuickSettingsMenuType.Submenu;
    icon?: string;
    children: IQuickSettingsMenuItem[];
}

export interface IQuickSettingsMenuChoice extends IQuickSettingsMenuBase {
    type: QuickSettingsMenuType.Choice;
    icon?: string;
    onClick: (menuContext?: any, itemContext?: IQuickSettingsMenuChoice) => void;
    rightIcons?: IconIdentifier[];
    context?: ItemContext;
}

export interface IQuickSettingsIconDefinition {
    icon: IconIdentifier;
    title?: string;
    iconClass?: string;
    clickable?: boolean;
    onClick?: (event: MouseEvent, menuContext?: any, itemContext?: ItemContext) => void;
}

export type IQuickSettingsMenuRegularItem =
    | IQuickSettingsMenuCheckbox
    | IQuickSettingsSubmenu
    | IQuickSettingsMenuChoice;

export interface IQuickSettingsMenuSeparator extends IQuickSettingsMenuBase {
    type: QuickSettingsMenuType.Separator;
}

export type IQuickSettingsMenuItem =
    | IQuickSettingsMenuGroup
    | IQuickSettingsMenuRadio
    | IQuickSettingsMenuSeparator
    | IQuickSettingsMenuRegularItem;
